import axiosInstance from "../../utility/axios";
import { AppDispatch } from "../../store/store";
import {
  setCompliance,
  setLoading,
  setLoadingComplianceId,
} from "../../store/slices/compliance";
import { toast } from "sonner";
import { getErrorMessage } from "../apiError";
import {
  IAssignLawyer,
  IAssignLawyerResponseData,
  IComplianceResponseData,
} from "../../store/types/compliance";
import { IApiResponse } from "@/src/store/types/api-response";

const complianceEndpoint = "/compliance/api/v1/compliance/";

export const get_compliances = async (
  dispatch: AppDispatch,
  offset: number,
  limit: number,
) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get<
      IApiResponse<IComplianceResponseData>
    >(`${complianceEndpoint}process-requests`, { params: { offset, limit } });

    dispatch(setCompliance(response.data));
  } catch (error) {
    toast.error(getErrorMessage(error, "Failed to load compliance"));
  } finally {
    dispatch(setLoading(false));
  }
};

export const assign_lawyer = async (
  dispatch: AppDispatch,
  data: IAssignLawyer,
  complianceId: number,
): Promise<boolean> => {
  dispatch(setLoadingComplianceId(complianceId));
  try {
    const response = await axiosInstance.post<
      IApiResponse<IAssignLawyerResponseData>
    >(`${complianceEndpoint}assignments`, data);
    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to assign lawyer");
    }
    toast.success(response.data.message || "Lawyer assigned successfully");
    return true;
  } catch (error) {
    toast.error(getErrorMessage(error, "Failed to assign lawyer"));
    return false;
  } finally {
    dispatch(setLoadingComplianceId(null));
  }
};
